import React from 'react';
import ReactMarkdown from 'react-markdown';

const formatTextToMarkdown = (text: string) => {
  let formattedText = text;

  // formattedText = formattedText.replace(/([^\n])(\d+\.\s)/g, '$1\n$2');

  // formattedText = formattedText.replace(/([^\n])(-\s)/g, '$1\n$2');

  // formattedText = formattedText.replace(/([A-Za-z ]+):/g, '\n**$1:**\n');

  return formattedText;
};

type FormattedTextProps = {
  text: string | undefined;
}

const FormattedText = ({ text }: FormattedTextProps) => {
  if (!text) {
    return null;
  }
  
  const markdownText = formatTextToMarkdown(text);

  return (
    <ReactMarkdown>
      {markdownText}
    </ReactMarkdown>
  );
};

export default FormattedText;
